<script lang="ts" setup>
import CityColumn from '~/components/city/CityColumn.vue'
import CityItem from '~/components/city/CityItem.vue'
import BasicInput from '~/components/form-elements/BasicInput.vue'
import BasicInputDecorator from '~/components/form-elements/BasicInputDecorator.vue'
import { splitIntoColumns } from '~/helpers/array-helper'
import { useCityStore } from '~/store/city'

const cityStore = useCityStore()
const { alphabetCities, filteredCities } = storeToRefs(cityStore)

const alphabetColumns = ['А-К', 'Л-С', 'Т-Я']

const searchCols = computed(() => {
  return splitIntoColumns(filteredCities.value);
});
</script>

<template>
  <div
    v-if="cityStore.popupStatus"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-[rgba(0,0,0,.5)]"
    @click.self="cityStore.closeCityPopup()"
  >
    <div class="max-h-[80vh] min-h-[80vh] w-full max-w-4xl overflow-y-auto rounded-xl bg-white p-6">
      <div class="mb-4 flex items-center justify-between">
        <strong class="text-xl font-semibold">
          Выберите город
        </strong>

        <button @click="cityStore.closeCityPopup()">
          <SvgIcon class="!size-5 text-main-dark" name="outlined/close" />
        </button>
      </div>

      <BasicInputDecorator class="relative">
        <BasicInput
          v-model="cityStore.filter.query"
          class="[&_.basic-input-group]:!rounded-2xl"
          :is-border="false"
          placeholder="Введите название города"
        />

        <div class="absolute right-4 top-[2px] flex h-full items-center">
          <a
            v-if="cityStore.filter.query !== null && cityStore.filter.query !== ''"
            href="#"
            @click.prevent="cityStore.filter.query = null"
          >
            <SvgIcon class="!size-6 fill-black" name="outlined/clear" />
          </a>
          <SvgIcon v-else class="!size-6" name="outlined/new-search" />
        </div>
      </BasicInputDecorator>

      <div class="flex flex-col sm:flex-row">
        <template v-if="cityStore.filter.query === null || cityStore.filter.query === ''">
          <CityColumn class="mt-4 sm:mr-10" title="Популярные">
            <ul class="space-y-1">
              <CityItem v-for="city in cityStore.citiesData.popular" :key="city.id" :city="city" />
            </ul>
          </CityColumn>

          <CityColumn
            v-for="(column, index) in alphabetCities"
            :key="index"
            class="mt-4 last:mr-0 sm:mr-10"
            :title="alphabetColumns[index]"
          >
            <ul class="space-y-1">
              <CityItem v-for="city in column" :key="city.id" :city="city" />
            </ul>
          </CityColumn>
        </template>
        <template v-else>
          <CityColumn
            v-for="(column, index) in searchCols"
            :key="index"
            class="mt-4 last:mr-0 sm:mr-10"
          >
            <ul class="space-y-1">
              <CityItem v-for="city in column" :key="city.id" :city="city" />
            </ul>
          </CityColumn>

          <b v-if="!filteredCities.length" class="mt-2 font-medium">Нет результатов.</b>
        </template>
      </div>
    </div>
  </div>
</template>
